// Tab "Convite" do EditUserModal (PO1-2022).
// Botão para disparar e-mail de ativação ao usuário. Disponível quando o
// usuário ainda não tem senha definida (ou para reenviar caso o link tenha
// expirado).

import React, { useState, useCallback } from "react";
import { Button } from "reactstrap";

import { sendActivationEmail } from "services/usersApi";
import { useToast } from "hooks/toast";
import { AUTOPILOT_COLORS } from "components/autopilot/styles";

export default function UserInviteTab({ user }) {
  const [sending, setSending] = useState(false);
  const [lastSentTo, setLastSentTo] = useState(null);
  const { addToast } = useToast();

  const hasPasswordHub = !!user.hasPasswordHub;

  const handleSend = useCallback(async () => {
    if (!user) return;
    setSending(true);
    try {
      const result = await sendActivationEmail(user.id);
      setLastSentTo(result.sentTo || user.email);
      addToast({
        place: "tr",
        type: "success",
        title: "E-mail enviado",
        description: `Link de ativação enviado para ${result.sentTo || user.email}.`,
        icon: "tim-icons icon-check-2",
      });
    } catch (err) {
      console.error("[UserInviteTab] send:", err);
      const message =
        (err.response && err.response.data && err.response.data.error) ||
        "Erro ao enviar convite";
      addToast({
        place: "tr",
        type: "danger",
        title: "Erro",
        description: message,
        icon: "tim-icons icon-alert-circle-exc",
      });
    } finally {
      setSending(false);
    }
  }, [user, addToast]);

  return (
    <div>
      <p style={{ color: AUTOPILOT_COLORS.title, fontSize: 14, marginBottom: 8 }}>
        Convite por e-mail
      </p>
      <p style={{ color: AUTOPILOT_COLORS.muted, fontSize: 12, marginBottom: 16 }}>
        Envia um e-mail para <strong>{user.email}</strong> com link de ativação.
        O usuário define a própria senha e entra direto no Hub. Link válido por
        7 dias e pode ser usado uma única vez.
      </p>

      {hasPasswordHub && (
        <div
          style={{
            background: AUTOPILOT_COLORS.statusWarningBg,
            borderLeft: `3px solid ${AUTOPILOT_COLORS.statusWarning}`,
            padding: "10px 14px",
            color: AUTOPILOT_COLORS.muted,
            fontSize: 12,
            marginBottom: 16,
          }}
        >
          ⚠ O usuário já tem senha cadastrada. Reenviar o convite vai gerar um
          novo link, mas a senha atual continua válida até o usuário usar o
          link e redefini-la.
        </div>
      )}

      {lastSentTo && (
        <div
          style={{
            background: AUTOPILOT_COLORS.statusSuccessBg,
            borderLeft: `3px solid ${AUTOPILOT_COLORS.statusSuccess}`,
            padding: "10px 14px",
            color: AUTOPILOT_COLORS.muted,
            fontSize: 12,
            marginBottom: 16,
          }}
        >
          ✓ Convite enviado para {lastSentTo}.
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button color="primary" onClick={handleSend} disabled={sending}>
          {sending
            ? "Enviando…"
            : lastSentTo
            ? "Reenviar convite"
            : "Enviar convite"}
        </Button>
      </div>
    </div>
  );
}
